const unreachable = (t: never): never => {
  throw new Error(`this was supposed to be unreachable ${t}`);
};
export default unreachable;
